export default class LoginRequest {
    useContexts: boolean;

    constructor() {
        this.useContexts = false;
    }

}
